import React, { useState } from "react";
import "./service.css";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header1 from "./header1";


const App = () => {
  const [activeService, setActiveService] = useState(null);

  const toggleHover = (service) => {
    setActiveService((prev) => (prev === service ? null : service));
  };

  const renderServiceOverlay = (serviceName, overlayContent) => {
    return (
      activeService === serviceName && (
        <div className={`${serviceName}-overlayv`}>{overlayContent}</div>
      )
    );
  };

  return (
    <div>
      <div className="header1">
      <Header1/>
      </div>
      <div className="Appv">
        <div className="rectangle-parentv">
        <a href="/">
        <p className='titlename1'>VREON TECH INDIA PVT LTD</p>
        </a>
          <div className="frame-childv" />
          <b className="homev">
            <a href="#home">
              <Link to="/">HOME</Link>
            </a>
          </b>
          <b className="aboutv">
            <a href="#about">
              <Link to="/about">ABOUT</Link>
            </a>
          </b>
          <b className="service2v">
            <a href="#services">
              <Link to="/service">SERVICES</Link>
            </a>
          </b>
          <b className="portfoliov">
            <a href="#portfolio">
              <Link to="/portfolio">PORTFOLIO</Link>
            </a>
          </b>

          <b className="ourproducts1v">
            <a href="#ourproducts">
              <Link to="/products">PRODUCTS</Link>
            </a>
          </b>
          <b className="contactv">
            <a href="#contact">
              <Link to="/contact">CONTACT</Link>
            </a>
          </b>
          <a href="/">
          <img className="image-2-iconv" alt="" src="/logo.png" />
          </a>
        </div>

        <div
          className="disaster-management-container-wrapperv"
          onMouseEnter={() => toggleHover("firePrevention")}
          onMouseLeave={() => toggleHover(null)}
        >
          <div
            className={`disaster-management-containerv ${activeService === "firePrevention" ? "transparent" : ""
              }`}
          >
            <b className="disaster-management1v">Disaster Management</b>
            <img className="disaster-1-iconv" alt="" src="disaster.png" />
          </div>

          {renderServiceOverlay(
            "firePrevention",
            <div className="fire-prevention-systemv">
              <div className="fire-textv">Fire Prevention System</div>
              <b className="disaster-managementv">Disaster Management </b>
            </div>
          )}
        </div>

        <div
          className="vr-events-container-wrapperv"
          onMouseEnter={() => toggleHover("eventManagement")}
          onMouseLeave={() => toggleHover(null)}
        >
          <div
            className={`vr-events-containerv ${activeService === "eventManagement" ? "transparent" : ""
              }`}
          >
            <b className="vr-events1v">VR Events</b>
            <img className="vrevents-1-iconv" alt="" src="vrevents.png" />
          </div>

          {renderServiceOverlay(
            "eventManagement",
            <div className="event-managementv">
              <div className="event-textv">Event Management</div>
              <b className="vr-eventsv">VR Events </b>
            </div>
          )}
        </div>

        <div
          className="education-container-wrapperv"
          onMouseEnter={() => toggleHover("education")}
          onMouseLeave={() => toggleHover(null)}
        >
          <div
            className={`education-containerv ${activeService === "education" ? "transparent" : ""
              }`}
          >
            <b className="education1v">Education</b>
            <img className="education-1-iconv" alt="" src="education.png" />
          </div>

          {renderServiceOverlay(
            "education",
            <div className="vr-learningv">
              <div className="vr-learning-textv">
                <span>VR</span>
                <span className="spanv">{` `}</span>
                <span>Learning</span>
              </div>
              <b className="educationv">Education </b>
              <div className="iq-analysis-tool-containerv"> IQ analysis Tool</div>
            </div>
          )}
        </div>

        <div
          className="edutainment-container-wrapperv"
          onMouseEnter={() => toggleHover("edutainment")}
          onMouseLeave={() => toggleHover(null)}
        >
          <div
            className={`edutainment-containerv ${activeService === "edutainment" ? "transparent" : ""
              }`}
          >
            <b className="edutainment1v">Edutainment</b>
            <img className="edutainmaent-1-iconv" alt="" src="edutainmaent.png" />
          </div>

          {renderServiceOverlay(
            "edutainment",
            <>
              <div className=" magic-mirrorv">
                <div className="magic-textv">Magic Mirror</div>
                <b className="edutainmentv">Edutainment </b>
              </div>
              <div className="vr-rowingv">
                <div className="vr-textv">VR Rowing</div>
              </div>
            </>
          )}
        </div>

        <div
          className="industry-container-wrapperv"
          onMouseEnter={() => toggleHover("industry")}
          onMouseLeave={() => toggleHover(null)}
        >
          <div
            className={`industry-containerv ${activeService === "industry" ? "transparent" : ""
              }`}
          >
            <b className="industry1v">Industry</b>
            <img className="indusrt-1-iconv" alt="" src="indusrt.png" />
          </div>

          {renderServiceOverlay(
            "industry",
            <>
              <div className="constructionv">
                <div className="cons-textv">Construction</div>
                <b className="industryv">Industry </b>
              </div>
              <div className="automobilev">
                <div className="auto-textv">Automobile</div>
              </div>
              <div className="healthcarev">
                <div className="health-textv">Healthcare</div>
              </div>
              <div className="architecturev">
                <div className="arch-textv">Architecture</div>
              </div>
            </>
          )}
        </div>

        <div className="desktop-4v">
          <div className="objects">
          <div className="desktop-4-childv" />
          <div className="desktop-4-itemv" />
          <div className="desktop-4-innerv" />
          <div className="rectangle-divv" />
          <div className="desktop-4-child1v" />
          <div className="desktop-4-child2v" />
          </div>
          

          <div className="our-servicev">
            <span>
              <span>Our</span>
            </span>
            <span className="servicev">
              <span>{` `}</span>
              <span className="service1v">Services</span>
            </span>
          </div>
          <img className="image-4-iconv" alt="" src="/servicePicture1.png" />
          <div className="desktop-4-child3v" >
          <b className="explore-all-yourv">Explore all our services</b>
          </div>
          
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default App;
